import styled from 'styled-components'

export const Container = styled.div`
  background-color: var(--neutral-theme);
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
`

export const Footer = styled.div`
  width: 100%;
  padding: 16px 24px;
`
